import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { push } from 'connected-react-router';

import Button from '../../Button';
import selectedBCT from '../../../Actions/Dashboard/selectedBCT';
import { addPathwayBarrier } from '../../../Actions/Dashboard/pathwaybarriers';
import { getPathwayPlan } from '../../../Actions/Dashboard/pathwayplan';

class BCT extends React.Component {
  click(action, bct, barrier) {
    this.props.dispatch(selectedBCT({ bct, barrier }));
    switch (action) {
      case 'plan':
        this.props.dispatch(push(`/dashboard/plan?bct=${bct.id}&barrier=${barrier.id}`));
        break;
      case 'note':
        this.props.dispatch(push(`/dashboard/note?bct=${bct.id}&barrier=${barrier.id}`));
        break;
      case 'diary':
        this.props.dispatch(push(`/dashboard/diary?bct=${bct.id}&barrier=${barrier.id}`));
        break;
      case 'task':
        this.props.dispatch(push(`/dashboard/task?bct=${bct.id}&barrier=${barrier.id}`));
        break;
      case 'addtoplan':
        this.props.dispatch(addPathwayBarrier({
          bct_id: bct.id,
          pathway: this.props.pathway,
          b_c_t_pathway_barrier_id: bct.pivot.id,
        }));
        setTimeout(() => {
          this.props.dispatch(getPathwayPlan(this.props.pathway));
        }, 1000);
        break;
      default:
    }
  }

  render() {
    const bct = this.props.data;
    const { barrier } = this.props;

    let isChecked = false;

    this.props.existingplan.map((r) => {
      if (!r || !bct.pivot) return null;
      if (r === bct.pivot.id) {
        isChecked = true;
      }
      return null;
    });

    let buttonText = '';
    const action = this.props.action || bct.action;
    switch (action) {
      case 'plan':
        buttonText = 'Make a plan';
        break;
      case 'note':
        buttonText = 'Make a note';
        break;
      case 'diary':
        buttonText = 'Update your diary';
        break;
      case 'task':
        buttonText = 'Create a task';
        break;
      case 'addtoplan':
        buttonText = (isChecked ? 'Remove from your story' : 'Add to your story');
        break;
      default:
        buttonText = '';
    }

    return (
      <li>
        <label>
          { isChecked ? <input type="checkbox" checked /> : null }
          <div className="comb_challenges_item_inner">
            <div>
              <p><img src={`https://www.livewelldorset.co.uk/site/images/icon/habithacker/${bct.reg_name.toLowerCase().replace(/\s/g, '-').replace('/', '')}.svg`} alt={bct.icon} height="101" /></p>
              <h3>{bct.name}</h3>
              <p>{bct.description}</p>
              <p><Button
                onClick={() => {
                  this.click(action, bct, barrier);
                }}
                label={buttonText}
              />
              </p>
            </div>
          </div>
        </label>
      </li>
    );
  }
}

BCT.propTypes = {
  data: PropTypes.object.isRequired,
  barrier: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  existingplan: PropTypes.array,
  action: PropTypes.string,
};

BCT.defaultProps = {
  action: false,
  existingplan: [],
};

export default connect(state => ({ pathway: state.pathway, existingplan: state.pathwayplanselected }), dispatch => ({ dispatch }))(BCT);



// WEBPACK FOOTER //
// ./src/Components/Dashboard/Modules/BCT.jsx